<form [formGroup]="rewardTypeForm">
  <div class="modal-body">
    <div class="form-group row">
      <label class="col-md-3 control-label">Name</label>
      <div class="col-md-9">
        <input type="text" formControlName="rewardTypeName" class="form-control" name="rewardType" />
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-4">
        <div *ngIf="index === null">
          <button class="btn btn-attention" title="Cancel" (click)="rewardTypeForm.reset()">
            <fa-icon [icon]="faTimes"></fa-icon>
          </button>
          <button
            id="create-reward-type"
            class="btn btn-dark-blue"
            type="button"
            (click)="emitEvent('add')"
            title="Add Reward Type"
          >
            <fa-icon [icon]="faPlus"></fa-icon>
          </button>
        </div>
        <div *ngIf="index !== null">
          <button class="btn btn-attention" title="Cancel" (click)="resetEdit()">
            <fa-icon [icon]="faTimes"></fa-icon>
          </button>
          <button
            id="create-reward-type"
            class="btn btn-dark-blue"
            type="button"
            (click)="emitEvent('save', index)"
            title="Save"
          >
            <fa-icon [icon]="faSave"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
